<template>
  <sui-segment raised>
    <sui-message align="center" error v-if="error">
      <h3>{{ $t('strError') }}</h3>
      <p>{{ error }}</p>
      <sui-button @click="clickBack" color="red" fluid>{{ $t('btnBackToShop') }}</sui-button>
    </sui-message>
    <sui-message align="center" v-if="!error">
      <h3>{{ $t('strAbortSuccess') }}</h3>
      <p>{{ $t('strBackToShop') }}</p>
      <sui-button @click="clickBack" color="red" fluid>{{ $t('btnBackToShop') }}</sui-button>
    </sui-message>
    <sui-dimmer :active="loading">
      <sui-loader>{{ $t('strLoading') }}</sui-loader>
    </sui-dimmer>
  </sui-segment>
</template>

<script>
  import ApiService from '@/services/ApiService.js'

  export default {
    name: 'Fail',
    components: {
      ApiService
    },
    metaInfo() {
      return {
        title: this.$t('strAbortSuccess'),
        meta: [
          /*{ vmid: 'description', name: 'description', content: 'Der Shop f�r Ihre LAN1 Voucher' }*/
        ]
      }
    },
    data() {
      return {
        error: '',
        loading: true,
      }
    },
    methods: {
      clickBack() {
        this.$router.push('/')
      },
    },
    async created() {
      let response = await ApiService.postAbortTransaction({ token: this.$route.params.token })
      this.loading = false;
      if (response.status == 200) {
        this.error = ''
      } else {
        this.$swal(this.$t('error'), this.$t(response.data.error), 'error')
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
